import { fetchBlobData, fetchData, postData } from "."

const MODULE_PATH = "/deliveries"

export default {
  getDeliveries(storeId: number | null, driverId: number | null, status: DeliveryStatus | null): Promise<Delivery[]> {
    let url = `${MODULE_PATH}`
    const query: string[] = []
    if (storeId) query.push(`StoreId=${storeId}`)
    if (driverId) query.push(`driverId=${driverId}`)
    if (status !== null) query.push(`status=${status}`)
    if (query.length) url += "?" + query.join("&")
    return fetchData<Delivery[]>(url)
  },
  getDeliveryInfo(deliveryId: number): Promise<DeliveryInfo> {
    return fetchData<DeliveryInfo>(`${MODULE_PATH}/${deliveryId}`)
  },
  getSignature(deliveryId: number): Promise<Blob> {
    return fetchBlobData(`${MODULE_PATH}/${deliveryId}/Signature`)
  },
  resendToDevice(deliveryId: number): Promise<void> {
    return fetchData<void>(`${MODULE_PATH}/${deliveryId}/Resend`)
  },
  setDeliveryPriorities(priorities: Record<number, number>): Promise<void> {
    return postData(`${MODULE_PATH}/DeliveryPriorities`, priorities)
  }
}

export interface Delivery {
  id: number
  orderId: number
  batchId: number
  status: DeliveryStatus
  priority: number
  customerName: string
  customerStreet: string
  customerCity: string
  customerState: string
  customerZip: string
  customerPhone: string
  amountDue: number
  driverName: string
  dateCreated: Date
}

export interface DeliveryInfo {
  storeId: number
  storeName: string
  storeDeliveryId: number
  storeDeliveryBatchId: number
  driverName: string
  customerName: string
  customerStreet: string
  customerCity: string
  customerState: string
  customerZip: string
  customerPhone: string
  dateCreated: Date
  amountDue: number
  paymentMethod?: DeliveryPaymentType
  status: DeliveryStatus
  signatureTimestamp?: Date
  recipient: string
  consultationRequested: boolean
  priority: number
  active: boolean
}

export enum DeliveryStatus {
  PendingUpload = 0,
  PendingDelivery = 1,
  Delivered = 2,
  NotDelivered = 3
}

export enum DeliveryPaymentType {
  None = 0,
  Cash = 1,
  Check = 2,
  CreditCard = 4,
  HouseAccount = 8,
  Other = 4096
}
